import jwtAuthAxios from './auth/jwtAuth';

const subscriptionServices = {};

subscriptionServices.getSubscriptionPlans = async () => {
  const { data } = await jwtAuthAxios.get('/subscription_plans');
  return data;
};

export default subscriptionServices;
